import styles from "./DeleteAllHistoryModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import Checkbox from "shared/@forms/Checkbox";
import { useState } from "react";
import { Ok } from "react-ikonate";

/**
 *
 * Modal used for deleting content history in the members tab of the groups page.
 */

export function DeleteAllHistoryModal({ isOpen, onClose, onClick, continueBool }) {
  const [checked, setChecked] = useState(continueBool);
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.containerContainer}>
      <div className={styles.modalBackground} onClick={onClose} />
      <div className={styles.container}>
        <div className={styles.bold}>DELETE ALL HISTORY</div>
        <div className={styles.hr} />
        <div className={styles.description}>
        Confirm that you would like to delete all content older than 30 days. History was last deleted on [MM/DD/YYYY at HH:MM AM].
        </div>

        <div className={classNames(styles.checkboxContainer, checked && styles.checked)} onClick={() => setChecked(!checked)}>

          <div className={classNames(styles.icon, !checked && styles.hidden)}>
            <Ok />
          </div>
          
        </div>
        <div className={styles.checkboxLabel}>Delete even if group is not a controlled LOS group.</div>

       

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button className={styles.button} onClick={() => onClick(checked)}>
            DELETE
          </button>
        </div>
      </div>
    </div>
  );
}

DeleteAllHistoryModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  continueBool: PropTypes.bool,
};
